import LoginFormComponent from '../../features/auth/components/LoginForm';

const Login = () => {
    return (
        <>
            <LoginFormComponent />
        </>
    )
}

export default Login;